// extracted by mini-css-extract-plugin
export var rightPanelOpenOld = "_ek-0";